<template>
    <section class="resume-section summary-section mb-5">
        <h2 class="resume-section-title text-uppercase font-weight-bold pb-3 mb-3">Página não encontrada</h2>
        <div class="resume-section-content">
            <p>A página que você tentou acessar não existe ou não está mais disponível.</p>
            <router-link to="/">Página inicial</router-link>
        </div>
    </section>
</template>
<script>
    export default {
        name: "NotFoundPage"
    }
</script>